import BasePolicy from '@/policies/BasePolicy.js';

export default class AttemptAuthorizationPolicy extends BasePolicy {
    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    viewAny(user, course) {
        if (
            user.hasPermissionTo('view all attempt authorizations') ||
            user.hasGroupPermissionTo('view all attempt authorizations')
        ) {
            return true;
        }

        if (!course) {
            return false;
        }

        return (
            user.hasPermissionViaCourseTo(course, 'view all attempt authorizations') ||
            user.hasGroupPermissionWithinCourse(course, 'view all attempt authorizations')
        );
    }

    /**
     * @param {User} user
     * @param {AttemptAuthorization} attemptAuthorization
     * @returns boolean
     */
    view(user, attemptAuthorization) {
        return (
            user.hasPermissionViaCourseTo(attemptAuthorization.course, 'view an attempt authorization') ||
            user.isStudentSupportOfCourse(attemptAuthorization.course)
        );
    }

    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    create(user, course) {
        const permission = 'create an attempt authorization';

        return (
            user.hasPermissionTo(permission) ||
            user.hasGroupPermissionTo(permission) ||
            user.hasUnlimitedScopePermissionTo(permission)
        );
    }

    /**
     * @param {User} user
     * @param {AttemptAuthorization} attemptAuthorization
     * @returns boolean
     */
    update(user, attemptAuthorization) {
        return (
            user.hasPermissionViaCourseTo(attemptAuthorization.course, 'edit an attempt authorization') ||
            user.hasGroupPermissionWithinCourse(attemptAuthorization.course, 'edit an attempt authorization')
        );
    }

    /**
     * @param {User} user
     * @param {AttemptAuthorization} attemptAuthorization
     * @returns boolean
     */
    delete(user, attemptAuthorization) {
        return (
            user.hasPermissionViaCourseTo(attemptAuthorization.course, 'delete an attempt authorization') ||
            user.hasGroupPermissionWithinCourse(attemptAuthorization.course, 'delete an attempt authorization')
        );
    }
}
